import { createFileRoute, redirect } from "@tanstack/react-router";

import { HomePageRoute } from "../components/home/HomePageRoute";
import { SpacesPage } from "../components/spaces/SpacesPage";

/**
 * `/$org/spaces` — every space in the organization; each row opens the
 * space (`/$org/spaces/$spaceId`). It sits beside Home's sidebar, whose
 * Spaces group links here, while the rail selects Spaces
 * (components/home/homePaths).
 */
function SpacesRouteView() {
  return (
    <HomePageRoute>
      <SpacesPage />
    </HomePageRoute>
  );
}

export const Route = createFileRoute("/$org/spaces/")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: SpacesRouteView,
});
